import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// #region agent log
try {
  fetch('http://127.0.0.1:7242/ingest/0061837b-d31b-4bc9-b253-97f40228a2c8',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'index.js:8',message:'index.js loaded',data:{hasRoot:!!document.getElementById('root')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
} catch(e) {
  console.error('Debug log error:', e);
}
// #endregion

try {
  const rootElement = document.getElementById('root');
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/0061837b-d31b-4bc9-b253-97f40228a2c8',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'index.js:15',message:'Creating root',data:{hasRootElement:!!rootElement},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  const root = ReactDOM.createRoot(rootElement);
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/0061837b-d31b-4bc9-b253-97f40228a2c8',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'index.js:22',message:'Root created, rendering',data:{},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/0061837b-d31b-4bc9-b253-97f40228a2c8',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'index.js:30',message:'Error in index.js',data:{error:error.message,stack:error.stack},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
  // #endregion
  console.error('Error rendering app:', error);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
